export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            爆料投稿
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8">
            你有独家猛料？发现热门事件？欢迎向我们投稿，一起围观最新吃瓜事件
          </p>
          <div className="bg-background-100 border border-background-200/70 rounded-2xl p-6 md:p-8">
            <div className="flex flex-col sm:flex-row items-center gap-6">
              <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-send-line text-2xl text-primary-600"></i>
              </div>
              <div className="text-left flex-1">
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">
                  投稿邮箱
                </h3>
                <p className="text-sm text-foreground-600 mb-3">
                  请将爆料内容、相关图片或链接发送至以下邮箱，我们的编辑团队将第一时间审核并发布
                </p>
                <a
                  href="mailto:tougao@51baoliao.com"
                  className="inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 font-medium text-sm whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-at-line"></i>
                  tougao@51baoliao.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}